import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from "src/environments/environment";

export interface FeriadoResponse {
  statusCode: number;
  status: string;
  content: Feriado[];
}
export interface Feriado {
  id?: number;
  fecha: Date;
  nombre: string;
  fechaCreacion?: Date;
  fechaActualizacion?: Date;
  usuarioActualizacion?: string;
}

export interface FeriadoActualizado {
  id?: number;
  fecha: Date;
  nombre: string;
  fechaCreacion?: Date;
  fechaActualizacion?: Date;
  usuarioActualizacion?: string;
  accion: 'A' | 'M' | 'B';
}

export interface FeriadoActualizadoPayload {
  id?: number;
  fecha: string;
  nombre: string;
  fechaActualizacion?: string;
  fechaCreacion?: string;
  usuarioActualizacion?: string;
  accion: 'A' | 'M' | 'B';
}

@Injectable({
  providedIn: 'root'
})
export class FeriadosService {
  endpoint = environment.apiBaseUrl + '/admin/feriados';

  constructor(private http: HttpClient) { }

  getFeriados(): Observable<FeriadoResponse> {
    return this.http.get<FeriadoResponse>(this.endpoint);
  }

  guardarCambios(feriados: FeriadoActualizadoPayload[]): Observable<any> {
    return this.http.post<any>(`${this.endpoint}/processList`, feriados);
  }


  deleteFeriado(id: number): Observable<void> {
    return this.http.delete<void>(`${this.endpoint}/${id}`);
  }

  duplicarFeriados(origen: number, destino: number): Observable<any> {
    return this.http.post<any>(`${this.endpoint}/duplicate?originYear=${origen}&targetYear=${destino}`, {});
  }



}
